module.exports = __webpack_public_path__ + "img/ELLA.8ec206bc.png";